"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageComponentValue = exports.getRichTextComponentValue = exports.getSingleLineComponentValue = exports.getBooleanComponentValue = exports.getNumericComponentValue = exports.getPropertiesTableValues = exports.getPriceVariant = exports.getContentChunks = exports.getItemRelationItems = void 0;
const getItemRelationItems = (cmp) => {
    var _a;
    return (_a = cmp === null || cmp === void 0 ? void 0 : cmp.content) === null || _a === void 0 ? void 0 : _a.items;
};
exports.getItemRelationItems = getItemRelationItems;
const getContentChunks = (cmp) => {
    var _a;
    return ((_a = cmp === null || cmp === void 0 ? void 0 : cmp.content) === null || _a === void 0 ? void 0 : _a.chunks) || [];
};
exports.getContentChunks = getContentChunks;
const getPriceVariant = (priceVariants, identifier) => {
    var _a, _b;
    return (_b = (_a = priceVariants === null || priceVariants === void 0 ? void 0 : priceVariants.find((pv) => (pv === null || pv === void 0 ? void 0 : pv.identifier) === identifier)) === null || _a === void 0 ? void 0 : _a.price) !== null && _b !== void 0 ? _b : 0;
};
exports.getPriceVariant = getPriceVariant;
const getPropertiesTableValues = (cmp) => {
    var _a, _b;
    const sections = {};
    (_b = (_a = cmp === null || cmp === void 0 ? void 0 : cmp.content) === null || _a === void 0 ? void 0 : _a.sections) === null || _b === void 0 ? void 0 : _b.forEach(({ title, properties }) => {
        const props = {};
        properties === null || properties === void 0 ? void 0 : properties.forEach(({ key, value }) => (props[key] = value));
        sections[title] = props;
    });
    return sections;
};
exports.getPropertiesTableValues = getPropertiesTableValues;
const getNumericComponentValue = (cmp) => {
    var _a;
    return (_a = cmp === null || cmp === void 0 ? void 0 : cmp.content) === null || _a === void 0 ? void 0 : _a.number;
};
exports.getNumericComponentValue = getNumericComponentValue;
const getBooleanComponentValue = (cmp) => {
    var _a;
    return (_a = cmp === null || cmp === void 0 ? void 0 : cmp.content) === null || _a === void 0 ? void 0 : _a.value;
};
exports.getBooleanComponentValue = getBooleanComponentValue;
const getSingleLineComponentValue = (cmp) => {
    var _a;
    return (_a = cmp === null || cmp === void 0 ? void 0 : cmp.content) === null || _a === void 0 ? void 0 : _a.text;
};
exports.getSingleLineComponentValue = getSingleLineComponentValue;
const getRichTextComponentValue = (cmp) => {
    var _a, _b;
    return (_b = (_a = cmp === null || cmp === void 0 ? void 0 : cmp.content) === null || _a === void 0 ? void 0 : _a.html) === null || _b === void 0 ? void 0 : _b.join('\n');
};
exports.getRichTextComponentValue = getRichTextComponentValue;
const getImageComponentValue = (cmp) => {
    var _a;
    return (_a = cmp === null || cmp === void 0 ? void 0 : cmp.content) === null || _a === void 0 ? void 0 : _a.images;
};
exports.getImageComponentValue = getImageComponentValue;
//# sourceMappingURL=get-component-values.js.map